import React, { useState } from 'react';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

const MuiSwitch = ({ value, label, colour = "primary", onChange = () => {} }) => {
    const [state, setState] = useState(value);

    const handleStateChange = checked => {
        setState(checked);
        onChange(checked);
    }

    return (
        <FormControlLabel
            control={
                <Switch
                    checked={state}
                    onChange={({ target: { checked } }) => handleStateChange(checked)}
                    color={colour}
                />
            }
            label={label}
        />
    );
};

export default MuiSwitch;